import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { addToAndroidWaitlist, checkEmailExists } from '../../lib/supabase';
import logo from '../../assets/app-icon-1024.png';
import './AndroidWaitlist.css';

const AndroidWaitlist = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      // Check if Supabase is properly configured
      if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
        setStatus('error');
        setMessage('Waitlist service is not configured. Please contact support.');
        return;
      }

      const { exists } = await checkEmailExists(email);
      
      if (exists) {
        setStatus('error');
        setMessage('This email is already on our waitlist!');
        return;
      }

      const { success, error } = await addToAndroidWaitlist(email);
      
      if (success) {
        setStatus('success');
        setMessage('Thank you! You\'ve been added to our Android waitlist.');
        setEmail('');
      } else {
        throw new Error(error || 'Failed to add to waitlist');
      }
    } catch (error) {
      console.error('Waitlist error:', error);
      setStatus('error');
      setMessage('Something went wrong. Please try again or contact support.');
    }
  };

  return (
    <div className="android-waitlist">
      <div className="waitlist-container">
        <motion.div 
          className="waitlist-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="logo-section">
            <img src={logo} alt="LunarLog AI" className="waitlist-logo" />
            <h1>LunarLog AI</h1>
          </div>
          
          <div className="waitlist-info">
            <h2>Android Version Coming Soon!</h2>
            <p>Join our waitlist to be the first to know when LunarLog AI is available on Android.</p>
          </div>

          <form onSubmit={handleSubmit} className="waitlist-form">
            <div className="form-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className={`email-input ${status === 'error' ? 'error' : ''}`}
                disabled={status === 'loading'}
                required
              />
              <button 
                type="submit" 
                className={`submit-btn ${status === 'loading' ? 'loading' : ''}`}
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Joining...' : 'Join Waitlist'}
              </button>
            </div>
            
            {message && (
              <motion.div 
                className={`message ${status}`}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                {message}
              </motion.div>
            )}
          </form>

          <div className="back-link">
            <a href="/" className="back-home">← Back to LunarLog AI</a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AndroidWaitlist;
